<template>
	<el-dialog title="样本列表未显示字段  (拖动操作)" :visible.sync="dialogVisible" width="1200px" :before-close="handleClose" :close-on-click-modal="false">
		<el-form :model="form" ref="validateForm" label-width="100px" class="demo-ruleForm">
			<el-form-item
				label="显示字段"
				prop="showAllList"
				:rules="[
					{ required: true, message: '显示字段不能为空', trigger: 'change'},
				]"
			>
				<el-select size="medium" style="width: 50%;" v-model="form.showAllList" @change="showAllListChange" @remove-tag="showAllListRemoveTag" multiple placeholder="请选择">
					<el-option v-for="item in originalAllList" :key="item.enfieldName" :label="item.chfieldName" :value="item.enfieldName">
					</el-option>
				</el-select>
			</el-form-item>
		</el-form>
		<div class="show">
			<div class="zzy">
				<el-row :gutter="20">
					<el-col :span="8">
						<el-card shadow="never" class="leftBox">
							<div style="margin-bottom: 20px;">左侧固定</div>
							<draggable class="leftSample" :list="list1" group="my-group">
								<div class="hideField" v-for="element in list1" :key="element.chfieldName">
									{{ element.chfieldName }}
									<i @click="removeTag(element, 1)" class="el-tag__close el-icon-close"></i>
								</div>
							</draggable>
						</el-card>
					</el-col>
					<el-col :span="8">
						<el-card shadow="never" class="centerBox">
							<div style="margin-bottom: 20px;">中间可选</div>
							<draggable class="centerSample" :list="list2" group="my-group">
								<div class="hideField" v-for="element in list2" :key="element.chfieldName">
									{{ element.chfieldName }}
									<i @click="removeTag(element, 2)" class="el-tag__close el-icon-close"></i>
								</div>
							</draggable>
						</el-card>
					</el-col>
					<el-col :span="8">
						<el-card shadow="never" class="rightBox">
							<div style="margin-bottom: 20px;">右侧固定</div>
							<draggable class="rightSample" :list="list3" group="my-group">
								<div class="hideField" v-for="element in list3" :key="element.chfieldName">
									{{ element.chfieldName }}
									<i @click="removeTag(element, 3)" class="el-tag__close el-icon-close"></i>
								</div>
							</draggable>
						</el-card>
					</el-col>
				</el-row>
			</div>
		</div>
		<span slot="footer" class="dialog-footer"><el-button size="medium" type="primary" @click="SampleOk">确 定</el-button></span>
	</el-dialog>
</template>

<script>
import draggable from 'vuedraggable';
export default {
	components: {
		draggable
	},
	data() {
		return {
			list1: [],
			list2: [],
			list3: [{ chfieldName: '操作' }],
			allList: [],
			id: '',
			dialogVisible: false,
			form: {
				showAllList: []
			},
			originalAllList: []
		};
	},
	methods: {
		removeTag(item, type) {
			this.form.showAllList = this.form.showAllList.filter(info => info != item.enfieldName)
			if (type == 1) {
				this.list1 = this.list1.filter((info) => info.enfieldName != item.enfieldName)
			} else if (type == 2) {
				this.list2 = this.list2.filter((info) => info.enfieldName != item.enfieldName)
			} else if (type == 3) {
				this.list3 = this.list3.filter((info) => info.enfieldName != item.enfieldName)
			}
		},
		showAllListChange(val) {
			console.log('已选择 :>> ', val);
			this.form.showAllList = this.form.showAllList.filter(info => info)
			let selectedList = [...this.list1, ...this.list2, ...this.list3]
			const extraItems = this.form.showAllList.filter(item1 => 
				!selectedList.some(item2 => item2.enfieldName === item1)
			);
			let newList = this.originalAllList.filter(info => 
				extraItems.some(val => info.enfieldName === val)
			);
			this.list2.push(...newList)
		},
		showAllListRemoveTag(val) {
			console.log('移除 :>> ', val);
			this.list1 = this.list1.filter(info => info.enfieldName != val)
			this.list2 = this.list2.filter(info => info.enfieldName != val)
			this.list3 = this.list3.filter(info => info.enfieldName != val)
		},
		SampleOk() {
			this.$refs.validateForm.validate((valid) => {
				if (valid) {
					if (this.list1.length > 4) {
						this.$message.warning('请设置左侧显示字段不超过四个');
						return false;
					}
					console.log(this.list1, this.list2, this.list3, this.allList);
					let that = this;
					let data = {
					leftFieldName: JSON.stringify(that.list1),
						centreFieldName: JSON.stringify(that.list2),
						rightFieldName: JSON.stringify(that.list3),
						qid: that.id
					};
					let params = {
						that: this,
						url: `${this.$config.service.modifyFieldConfig}`,
						method: 'POST',
						data: data,
						cb(res) {
							console.log(res);
							if (res.code == 0) {
								that.$message.success(res.message);
								that.dialogVisible = false;
								that.$emit('setOk');
							} else {
								that.$message.error(res.message);
							}
						}
					};
					this.$util.request(params);
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},

		loadData() {
			this.id = this.$route.query.id;

			//查询本问卷全部字段
			this.queryAllFieldName();
		},
		queryAllFieldName() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryAllFieldName}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log(res);
					if (res.code == 0) {
						that.allList = res.resultBody.questionsFieldMappings;
						that.originalAllList = res.resultBody.questionsFieldMappings
						//查询问卷左中右显示字段
						that.queryFieldConfig();
					} else {
						that.allList = [];
						that.originalAllList = [];
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		queryFieldConfig() {
			let that = this;
			let params = {
				that: this,
				url: `${this.$config.service.queryFieldConfig}`,
				method: 'POST',
				data: {
					qid: this.id
				},
				cb(res) {
					console.log('查询左中右', res);
					if (res.code == 0) {
						if (res.resultBody != '') {
							that.list1 = JSON.parse(res.resultBody.leftFieldName);
							that.list2 = JSON.parse(res.resultBody.centreFieldName);
							that.list3 = JSON.parse(res.resultBody.rightFieldName);
							let tempAllList = [...that.list1, ...that.list2, ...that.list3];

							that.form.showAllList = tempAllList.map(val => val.enfieldName);
							that.dialogVisible = true;
						} else {
							that.dialogVisible = true;
						}
					} else {
						that.$message.error(res.message);
						that.dialogVisible = true;
					}
				}
			};
			this.$util.request(params);
		},
		handleClose(done) {
			done();
			// this.$confirm('确认关闭？')
			// 	.then(_ => {
			// 		done();
			// 	})
			// 	.catch(_ => {});
		}
	}
};
</script>

<style scoped lang="scss">
.show {
	width: 1140px;
	margin: 0px auto;
	min-height: 300px;

	.zzy {
		margin-top: 20px;
		
		.hideField {
			line-height: 32px;
			border-radius: 4px;
			padding: 0 10px;
			border: 1px solid #EBEEF5;
			box-sizing: border-box;
			cursor: all-scroll;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.el-tag__close.el-icon-close {
				cursor: pointer;
				background-color: #C0C4CC;
				top: 0;
				flex-shrink: 0;
				color: #909399;
				font-size: 10px;
				border-radius: 10px;
				width: 13px;
				height: 13px;
				text-align: center;
				line-height: 13px;
			}
		}
		.hideField + .hideField{
			margin-top: 10px;
		}
		.leftSample,
		.centerSample,
		.rightSample {
			height: 215px;
			overflow-y: auto;
		}
	}
}
</style>
